<div class="main-container mat-app-background">
  @if (isMenuVisible) {
    <mat-toolbar class="primary mat-elevation-z2" color="primary">
      <div class="hide-gt-mobile">
        <button mat-icon-button (click)="sidenav.toggle()">
          <mat-icon>menu</mat-icon>
        </button>
      </div>
      <div class="pwa-back-button">
        <button mat-icon-button (click)="navigateBack()">
          <mat-icon>arrow_back</mat-icon>
        </button>
      </div>
      <ldw-logo></ldw-logo>
      <!-- TODO: hide navbuttons conditionally -->
      <div class="navbuttons hide-lt-mobile">
        @for (mitem of availableItems$ | async; track mitem) {
          <div>
            <a
              class="topbutton"
              mat-button
              [routerLink]="mitem.route"
              routerLinkActive="active-link"
              [matTooltipTouchGestures]="'off'"
              [matTooltip]="showToolTip() ? mitem.text : ''"
              >
              <mat-icon>{{ mitem.icon }}</mat-icon>
              <span class="hide-lt-tablet">&nbsp;{{ mitem.text }}</span>
            </a>
          </div>
        }
        @if (isWebDokuAvailable) {
          <ldw-menu [menuItems]="infoCommands">
            <a class="topbutton" mat-button [matTooltipTouchGestures]="'off'" [matTooltip]="showToolTip() ? 'Info' : ''">
              <mat-icon>info</mat-icon>
              <span class="hide-lt-tablet">&nbsp;Info</span>
            </a>
          </ldw-menu>
        }
        <ldw-menu [menuItems]="userCommands">
          <a class="topbutton" mat-button [matTooltip]="showToolTip() ? menuService.cmdUser.text : ''">
            <mat-icon>{{ menuService.cmdUser.icon }}</mat-icon>
            <span class="hide-lt-tablet">&nbsp;{{ menuService.cmdUser.text }}</span></a
            >
          </ldw-menu>
        </div>
        <span class="spacer"></span>
        @if (planningJobSelectionVisible) {
          <ldw-planning-job-select
            [initialValue]="selectedPlanningJob()?.name || ''"
            (jobChanged)="jobHasChanged($event)"
            />
        }
        <ldw-messages-button></ldw-messages-button>
        @if (searchButtonVisible) {
          <button
            mat-icon-button
            [routerLink]="menuService.cmdSearch.route"
            matTooltip="{{ showToolTip()? ('SEARCH.SEARCH' | translate):'' }}"
            routerLinkActive="active-link"
            >
            <mat-icon>{{ menuService.cmdSearch.icon }}</mat-icon>
          </button>
        }
        @if (bookmarkService.bookmarksAvailable) {
          <ldw-document-bookmarks-button></ldw-document-bookmarks-button>
        }
        @if (loading$ | async) {
          <mat-progress-bar mode="indeterminate" class="loadingbar"></mat-progress-bar>
        }
      </mat-toolbar>
    }

    <mat-sidenav-container>
      @if (isMenuVisible) {
        <mat-sidenav color="primary" #sidenav mode="over" opened="false" fxHide.gt-xs="true">
          <mat-nav-list>
            @for (mitem of availableItems$ | async; track mitem) {
              <div>
                <a mat-list-item [routerLink]="mitem.route" routerLinkActive="active-link">
                  <mat-icon>{{ mitem.icon }}</mat-icon>
                  <span>&nbsp;{{ mitem.text }}</span>
                </a>
              </div>
            }
            @if (isWebDokuAvailable) {
              <ldw-menu [menuItems]="infoCommands">
                <a mat-list-item>
                  <mat-icon>info</mat-icon>
                  <span>&nbsp;Info</span>
                </a>
              </ldw-menu>
            }
            <ldw-menu [menuItems]="userCommands">
              <a mat-list-item>
                <mat-icon>{{ menuService.cmdUser.icon }}</mat-icon>
                <span>&nbsp;{{ menuService.cmdUser.text }}</span>
              </a>
            </ldw-menu>
          </mat-nav-list>
        </mat-sidenav>
      }

      <mat-sidenav-content class="sidenav-content">
        <div class="main-outlet-container">
          <router-outlet></router-outlet>
        </div>

        @if (isMenuVisible) {
          <mat-toolbar class="secondary bottombar" color="secondary">
            <mat-icon class="bar-icon">person</mat-icon>
            <div class="bottomtext">{{ userName }}</div>
            @if (hasWebDokuName) {
              <mat-icon class="bar-icon">local_library</mat-icon>
            }
            @if (hasWebDokuName) {
              <div class="bottomtext">{{ webDokuName }}</div>
            }
            @if (hasInfoText) {
              <mat-icon class="bar-icon">info</mat-icon>
            }
            @if (hasInfoText) {
              <div class="bottomtext">{{ infoText }}</div>
            }
          </mat-toolbar>
        }
      </mat-sidenav-content>
    </mat-sidenav-container>
  </div>
